export default __webpack_public_path__ + "static/media/DisneySnowWhite1.8c6571b1.jpg";